<template>
  <div class="nav">
    <!--    <router-link tag="a" to="/" :class="type==1 ? 'nav-span nav-span-first choice': 'nav-span nav-span-first'">驿道旅游</router-link>
    <span class="nav-ver"></span>
    <router-link tag="a" to="/destination" :class="type==2 ? 'nav-span choice': 'nav-span'">目的地</router-link>
    <span class="nav-ver"></span>
    <router-link tag="a" to="/tourist" :class="type==3 ? 'nav-span choice': 'nav-span'">旅游攻略</router-link>
    <span class="nav-ver"></span>
    <router-link tag="a" to="/traffic" :class="type==4 ? 'nav-span choice': 'nav-span'">
      交通
      <ul class="traffic-ul">
        <li class="active">韶关南雄乌遂古道</li>
        <li>西南古道(乳源段)</li>
      </ul>
    </router-link>
    <span class="nav-ver"></span>
    <router-link tag="a" to="/boardAndLodging" :class="type==5 ? 'nav-span choice': 'nav-span'">食宿推荐</router-link>
    <span class="nav-ver"></span>
    <router-link tag="a" to="/activitiesCommunity" :class="type==6 ? 'nav-span choice': 'nav-span'">驿活动</router-link>
    <span class="nav-ver"></span>
    <router-link tag="a" to="/sound" :class="type==7 ? 'nav-span nav-span-last choice': 'nav-span nav-span-last'">驿声影</router-link> -->
    <div v-for="(item,index) in newOptions" :key="index" class="nav_div" v-if="index != newOptions.length-1">
      <div :class="type==item.value.sortnum ? 'nav-span choice': 'nav-span'" v-if="item.value" @click="goRouter(item.value.sortnum,item.value.id,item.children)"
        @mouseover="change">
        {{item.value.name}}
        <ul class="traffic-ul" v-show="item.value.sortnum == 4 && isShow">
          <li v-for="(item1,index) in ALLYiDao" :key='index' :class="trafficTip==index?'navLi':'' " @click.stop="goTraffic(item1.id,index)">{{item1.name}}</li>
        </ul>
        <ul class="traffic-ul destination-ul" v-show="item.value.sortnum == 2 && isShow">
          <li v-for="(item2,index) in ALLYiDao" :key='index' :class="tip==index?'navLi':'' " @click.stop="goDestination(item2.id,index,item.value.id)">{{item2.name}}</li>
        </ul>
      </div>
      <span class="nav-ver" v-if="item.noName"></span>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        options: [],
        newOptions: [],
        ALLYiDao: [],
        trafficTip: -1,
        targetid: '',
        tip: -1,
        isShow: true
      }
    },
    props: ["type"],
    methods: {
      getAll() {
        this.axios.post('api/b_navigatemag/getAll.do', this.qs(null)).then(res => {
          if (res.status == 200) {
            for (var i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].id == '0F6A99E7E25E4871AC6410B183DF9477') {
                res.data.data.splice(i, 1)
              }
            }

            for (let item of res.data.data) {
              if (item.pid == '') {
                this.options.push({
                  value: item,
                  children: []
                })
              }
            }
            for (let item of res.data.data) {
              if (item.pid != '') {
                for (var i = 0; i < this.options.length; i++) {
                  if (item.pid == this.options[i].value.id) {
                    this.options[i].children.push({
                      value: item
                    })
                    this.options[i].children.sort(function(p1, p2) {
                      return p1.value.sortnum - p2.value.sortnum
                    })
                  }
                }
              }
            }

            this.options.sort(function(p1, p2) {
              return p1.value.sortnum - p2.value.sortnum
            })


            for (let item of this.options) {
              this.newOptions.push(item)
              this.newOptions.push({
                noName: true,
              })
              if(this.type == item.value.sortnum){
                this.$emit('getNavID',item.value.id)
                console.log('getNavID');
                if(this.type==1){
                   sessionStorage.setItem("index_childrenId",item.children[0].value.id)
                }
                if(this.type==7){//如果是驿声影的话
                  this.$emit('getChildren',item.children)
                }else if(this.type==6){//如果是驿道商店
                  this.$emit('getStoreChildren',item.children)
                }
              }
            }
         
            // sessionStorage.setItem('sortnumoneID', this.newOptions[0].value.id)
          }
        })
      },
      getAllYiDao() {
        this.axios.post('api/l_yidaoinfo/getAll.do', this.qs(null)).then(res => {
          if (res.status == 200) {
            this.ALLYiDao = res.data.data
            this.targetid = res.data.data[0].id
            this.$emit('getTargetOneID',this.targetid)
          }
        })
      },
      goRouter(type, id,children) {
        switch (type) {
          case 1:
            this.$router.push({
              name: 'index'
            })
            break;
          case 2:
          console.log(2)
            this.$emit('getTargetid', this.targetid)
            this.resetSetItem('index_destination', 0)
            this.$router.push({
              name: 'destination',
              query: {
                navID: id,
                targetid:this.targetid
              }
            })
            break;
          case 3:
            this.$router.push({
              name: 'tourist',
              query: {
                navID: id
              }
            })
            break;
          case 4:
            this.$emit('getTargetid', this.targetid)
            this.resetSetItem('index', 0)
            this.$router.push({
              name: 'traffic',
              query: {
                targetid: this.targetid
              }
            })
            break;
          case 5:
            this.$router.push({
              name: 'boardAndLodging'
            })
            break;
          case 6:
            this.$router.push({
              name: 'activitiesCommunity'
            })
            // sessionStorage.setItem('active',JSON.stringify(children))
            break;
          case 7:
            this.$router.push({
              name: 'sound'
            })
            // sessionStorage.setItem('sound',JSON.stringify(children))
            break;
          default:
            break;
        }

      },
      goTraffic(id, index) {
        
        this.isShow = false
        this.$emit('getTargetid', id)
        this.$router.push({
          name: 'traffic',
          query: {
            targetid: id
          }
        })
        this.resetSetItem('index', index)
      },
      goDestination(id, index,navID) {
        console.log(navID)
        this.isShow = false
        this.$emit('getTargetid', id)
        this.$router.push({
          name: 'destination',
          query: {
            targetid: id,
            navID:navID
          }
        })
        this.resetSetItem('index_destination', index)
      },
      change() {
        this.isShow = true
      }
    },
    created() {
      window.addEventListener('setItem', () => {
        this.trafficTip = sessionStorage.getItem('index');
        if(sessionStorage.getItem('index_destination')){
          this.tip = sessionStorage.getItem('index_destination')
        }else{
          this.tip = sessionStorage.getItem('index_destination_a')
        }
        
      })
    },
    mounted() {
      this.getAll()
      this.getAllYiDao()
      this.trafficTip = sessionStorage.getItem('index');
      if(sessionStorage.getItem('index_destination')){
        this.tip = sessionStorage.getItem('index_destination')
      }else{
        this.tip = sessionStorage.getItem('index_destination_a')
      }
    }
  }
</script>

<style>
</style>
